import React from 'react';
import { useDispatch } from 'react-redux';
import * as ModalActions from '../../../stores/actions/modal';
import { reasonForNoAccess } from '../../../connection/utils';

interface Props {
	isProducer?: boolean;
	forReason?: reasonForNoAccess | null;
}

export default function NoRoomAccess(props: Props): JSX.Element {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	let titleText;
	if (props.forReason === 'roomDoesNotExist') {
		titleText = 'This Greenroom does not exist';
	} else if (props.forReason === 'roomWasDeleted') {
		titleText = 'This Greenroom has been deleted';
	} else {
		// forReason === notInvited and also catchall
		titleText = "You don't have access to that room";
	}

	let bodyText;
	if (props.forReason === 'roomDoesNotExist') {
		bodyText = 'Check the URL and try again';
	} else if (props.forReason === 'roomWasDeleted') {
		if (props.isProducer) {
			bodyText = <>If this was a mistake, it can be restored at <a href='https://admin.brandlive.com'>admin.brandlive.com</a></>
		} else {
			bodyText = 'Check the URL and try again';
		}
	} else {
		// forReason === notInvited and also catchall
		bodyText = "Make sure you have the correct permissions then try again";
	}

	return (
		<div className="info-modal no-room-access-modal">
			<div className="title-container">
				<h4 className='bl-font-header' style={{marginBottom: 0}}>{titleText}</h4>
			</div>

			<div className='body'>
				<span className="explanation bl-font-l1">{bodyText}</span>
			</div>

			<div className='footer'>
				<button className='no-room-access-btn ' data-testid="no-room-access-button" onClick={closeModal}>Close</button>
			</div>
		</div>
	);

}
